import './Features.css'

function Features() {
    return (
        <section className="features-01">
            <div className="container">
                <div className="features-01-wrap">
                    <div className="features-01-heading-wrap">
                        <h1
                            style={{
                                WebkitTransform: 'translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                                MozTransform: 'translate3d(0, 10%, 0) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                                msTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                transform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                opacity: 0.78,
                            }}
                            className="h2 features-01-heading"
                        >
                            Automatically Reverse Engineer Websites
                        </h1>
                    </div>
                    <div className="features-01-card-wrap">
                        <div className="features-01-card-top">
                            <div
                                style={{
                                    WebkitTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    MozTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    msTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    transform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    opacity: 0.78,
                                }}
                                className="features-01-card _1"
                            >
                                <div className="features-01-card-image-box">
                                    <img
                                        src="/new_requests.svg"
                                        loading="lazy"
                                        alt=""
                                        className="features-01-card-image-1"
                                    />
                                </div>
                                <div className="features-01-card-text-wrap">
                                    <h1 className="sub-h1 features-01-card-title">Precise Request Replication</h1>
                                    <div className="body-02 features-01-card-subtext _1">
                                        Replicate website requests exactly as they occur, making your scrapers indistinguishable from real browser activity.
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    WebkitTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    MozTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    msTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    transform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    opacity: 0.78,
                                }}
                                className="features-01-card"
                            >
                                <div className="features-01-card-image-box">
                                    <img
                                        src="/new_scalable.svg"
                                        loading="lazy"
                                        alt=""
                                        className="features-01-card-image-2"
                                    />
                                </div>
                                <div className="features-01-card-text-wrap">
                                    <h1 className="sub-h1 features-01-card-title">Scalable</h1>
                                    <div className="body-02 features-01-card-subtext">
                                        Efficiently scale your scraping projects to handle millions of pages with optimal performance.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="features-01-card-bottom">
                            <div
                                style={{
                                    WebkitTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    MozTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    msTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    transform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    opacity: 0.78,
                                }}
                                className="features-01-card"
                            >
                                <div className="features-01-card-image-box">
                                    <img
                                        src="/new_integration.svg"
                                        loading="lazy"
                                        alt=""
                                        className="features-01-card-image-3"
                                    />
                                </div>
                                <div className="features-01-card-text-wrap">
                                    <h1 className="sub-h1 features-01-card-title">Easy Integration</h1>
                                    <div className="body-02 features-01-card-subtext">
                                        Receive clean, readable code that's ready to integrate into your existing projects with minimal adjustments.
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    WebkitTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    MozTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    msTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    transform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    opacity: 0.78,
                                }}
                                className="features-01-card"
                            >
                                <div className="features-01-card-image-box">
                                    <img
                                        src="/new_support.svg"
                                        loading="lazy"
                                        alt=""
                                        className="features-01-card-image-2"
                                    />
                                </div>
                                <div className="features-01-card-text-wrap">
                                    <h1 className="sub-h1 features-01-card-title">Additional Support</h1>
                                    <div className="body-02 features-01-card-subtext">
                                        Effortlessly integrate captcha solvers, proxies, and manage rate limits to ensure uninterrupted scraping.
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    WebkitTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    MozTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    msTransform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    transform: 'translate3d(0, 10%, 0) scale(1) rotate(0deg) skew(0deg)',
                                    opacity: 0.78,
                                }}
                                className="features-01-card"
                            >
                                <div className="features-01-card-image-box">
                                    <img
                                        src="/new_error.svg"
                                        loading="lazy"
                                        sizes="(max-width: 479px) 100vw, (max-width: 767px) 74vw, (max-width: 991px) 80vw, (max-width: 1439px) 26vw, 311.9888916015625px"
                                        alt=""
                                        className="features-01-card-image-2"
                                    />
                                </div>
                                <div className="features-01-card-text-wrap">
                                    <h1 className="sub-h1 features-01-card-title">Error Handling</h1>
                                    <div className="body-02 features-01-card-subtext">
                                        Robust error detection with automatic retries and exception handling to ensure continuous scraping.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
 }

 export default Features;